<template>
    <div class="no-subscription">
        <i18n path="application.no-subscriptions.text">
            <a @click='openWebsite'>{{$t('application.no-subscriptions.link')}}</a>
        </i18n>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        openWebsite (){
            let win = window.open(`${this.$store.getters.managerUrl}`, '_blank');
            win.focus();
        },
    },
};
</script>

<style lang="scss">
.no-subscription{
    text-align: center;
    font-size: 30px;
    margin: 100px;

}
</style>



// WEBPACK FOOTER //
// src/components/page/Application/no-subscriptions.vue